export default "__VITE_ASSET__D3Mj0u6K__"